import * as differenceInCalendarDays from 'date-fns/difference_in_calendar_days';
import * as differenceInCalendarWeeks from 'date-fns/difference_in_calendar_weeks';
import * as differenceInCalendarMonths from 'date-fns/difference_in_calendar_months';
import * as differenceInCalendarYears from 'date-fns/difference_in_calendar_years';
import { DATE_DIFFS } from '../constants';
import { DateClausePeriod } from '../types';

export const getDateDifference = (
    endDate: Date,
    startDate: Date,
    period: DateClausePeriod
): number => {
    let dateDifference = 0;

    if (period === DATE_DIFFS.DAYS) {
        dateDifference = differenceInCalendarDays(endDate, startDate);
    }

    if (period === DATE_DIFFS.WEEKS) {
        dateDifference = differenceInCalendarWeeks(endDate, startDate);
    }

    if (period === DATE_DIFFS.MONTHS) {
        dateDifference = differenceInCalendarMonths(endDate, startDate);
    }

    if (period === DATE_DIFFS.YEARS) {
        dateDifference = differenceInCalendarYears(endDate, startDate);
    }

    // date-fns differenceIn* functions may return a negative value if startDate is before endDate
    // The difference is still valid as long as we ensure a positive value
    return dateDifference < 0 ? Math.abs(dateDifference) : dateDifference;
};

export default getDateDifference;



// WEBPACK FOOTER //
// ./src/utils/getDateDifference.ts